// @ts-nocheck
import {
    field,
    GfxPrimitiveElementModel,
} from '@blocksuite/block-std/gfx';
import type { SerializedXYWH } from '@blocksuite/global/utils';

type AttachmentKind = 'tag' | 'timestamp';

export class AttachmentChipElementModel extends GfxPrimitiveElementModel {
    @field()
    accessor xywh: SerializedXYWH = '[0,0,0,0]';

    @field()
    accessor label: string = '';

    @field()
    accessor bg: string = '#eeeeee';

    @field()
    accessor border: string = '#cccccc';

    @field()
    accessor textColor: string = '#333333';

    @field()
    accessor nodeId: string = '';

    @field()
    accessor kind: AttachmentKind = 'tag';

    override get rotate(): number {
        return 0;
    }

    get type(): string {
        return 'attachment-chip';
    }
}

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace BlockSuite {
        interface SurfaceElementModelMap {
            'attachment-chip': AttachmentChipElementModel;
        }
    }
}


